import React from 'react';

import thumbnailImage from '../../assets/images/blog/Talk_Logo.png';
import Nextcloud_Talk_Federation from '../../assets/images/blog/Nextcloud_Talk_Federation.png';
import Federated_Cloud_ID from '../../assets/images/blog/Federatet-Cloud-ID.png';
import Neue_Unterhaltung_erstellen from '../../assets/images/blog/Neue Unterhaltung erstellen.png';
import Federationnutzer_einladen from '../../assets/images/blog/Federationnutzer_einladen.png';
import nextcloudTalkPathconnect from '../../assets/images/blog/nextcloud-talk-pathconnect.png';

import {
  BlogContent,
  BlogHeading,
  BlogImage,
  BlogGallery
} from '../../components/blog';

const post = {
  id: 'nextcloud-talk-federation',
  slug: 'nextcloud-talk-federation',

  date: "2025-07-08T00:00:00.000Z",
  readTime: 5,
  categories: ["Nextcloud", "Talk", "Federation"],
  thumbnail: thumbnailImage,
  thumbnailUrl: thumbnailImage,
  thumbnailSize: 'medium',
  showInPostHeader: true,
  likes: 0,
  comments: [],

  searchableContent: "Nextcloud Talk Federation serverübergreifende Kommunikation dezentrale Kommunikation Open Source Messenger DSGVO Talk-Federation",

  translations: {
    de: {
      title: "Nextcloud Talk – Federation: Nextcloud-übergreifend kommunizieren",
      formattedDate: "08. Juli 2025",
      excerpt: "So kommunizierst du sicher über mehrere Nextcloud-Instanzen hinweg mit der Federation-Funktion in Talk.",
      searchableContent: "Nextcloud Talk Federation serverübergreifende Kommunikation dezentrale Kommunikation Open Source Messenger DSGVO Talk-Federation",
      content: () => (
        <BlogContent>
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Nextcloud Talk – Federation: Nextcloud-übergreifend kommunizieren</h1>

          <p>
            Nextcloud Talk eignet sich nicht nur für die sichere Kommunikation innerhalb eines Teams, dessen Mitglieder alle einen Account auf derselben Nextcloud-Instanz haben, sondern auch für die Kommunikation mit Mitgliedern einer anderen Nextcloud-Instanz. Dank der Federation-Funktion wird Talk zu einem dezentralen Kommunikationssystem, das es dir ermöglicht, über verschiedene Nextcloud-Instanzen hinweg sicher zu kommunizieren.
          </p>

          <BlogHeading>Federation in Nextcloud Talk</BlogHeading>

          <BlogImage 
            src={Nextcloud_Talk_Federation}
            alt="Schema der Federation zwischen zwei Instanzen"
            size="small"
          />

          <p>
            „Federation” bezeichnet die Fähigkeit, verschiedene unabhängige Nextcloud-Instanzen miteinander zu verbinden. So können Nutzer von Cloud A auch mit Nutzern von Cloud B kommunizieren, ohne dass die jeweiligen Accounts auf der anderen Cloud vorhanden sein müssen.
            Das ist vergleichbar mit dem E-Mail-System: Auch hier kannst du mit beliebigen Adressen kommunizieren, obwohl jede E-Mail bei einem anderen Anbieter liegt.
          </p>

          <BlogHeading>Federated-Cloud-ID</BlogHeading>

          <BlogImage 
            src={Federated_Cloud_ID}
            alt="Beispiel einer Federated-Cloud-ID in den Einstellungen"
            size="medium"
            caption="Federated-Cloud-ID am Beispiel der Instanz test.pathconnect.de"
          />

          <p>
            Über diese ID, die sich aus deinem Nutzernamen und der Nextcloud-Adresse zusammensetzt, können dich Nutzer einer anderen Nextcloud-Instanz erreichen. Du findest diese ID unter <strong>Einstellungen &gt; Teilen</strong>. Für den Nutzer „Demo“ auf der Instanz mit der Adresse „test.pathconnect.de“ lautet die Federated-Cloud-ID beispielsweise <code>Demo@test.pathconnect.de</code>.
          </p>

          <BlogHeading>Voraussetzungen für Federation</BlogHeading>

          <p>Damit die Verbindung in Talk über mehrere Instanzen hinweg funktioniert, müssen auf beiden Seiten einige Punkte erfüllt sein:</p>
          <ul className="list-none space-y-2 mb-4">
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>Die Talk-App muss installiert und konfiguriert sein.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>Beide Instanzen verfügen über eine sichere HTTPS-Verbindung mit gültigem Zertifikat.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>In den Einstellungen unter „Verwaltung” &gt; „Talk” muss die Option „Federation aktivieren” eingeschaltet sein.</span>
            </li>
          </ul>

          <BlogHeading>Unterhaltung mit einer Person von einer anderen Nextcloud-Instanz erstellen</BlogHeading>

          <p>
            Um eine neue Unterhaltung zu erstellen und eine Person von einer anderen Nextcloud-Instanz dazu einzuladen, öffne die Talk-App und klicke auf das Symbol mit der Sprechblase. Danach auf „Neue Unterhaltung erstellen“. Gib einen Namen ein und klicke auf „Teilnehmer hinzufügen“. 
            Gib im Suchfeld die Federated-Cloud-ID deines Gesprächspartners ein. Nach Auswahl wird der Benutzer mit einem Haken markiert. Klicke anschließend auf „Unterhaltung erstellen“.
          </p>

          <BlogGallery 
            images={[
              {
                src: Neue_Unterhaltung_erstellen,
                alt: "Screenshot Neue Unterhaltung erstellen"
              },
              {
                src: Federationnutzer_einladen,
                alt: "Federationnutzer einladen"
              }
            ]}
          />

          <BlogHeading>Vorteile der Federation für Unternehmen</BlogHeading>

          <ul className="list-none space-y-2 mb-4">
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>Dezentrale Kommunikation: Jeder behält seine eigene Infrastruktur</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>Keine Vendor-Lock-ins: Keine Abhängigkeit von Microsoft, Google, Zoom &amp; Co.</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-0.5">✅</span>
              <span>Interne und externe Teams vernetzen: Ideal für Kundenkommunikation oder Kooperationspartner</span>
            </li>
          </ul>

          <p>
            Dank Federation wird Nextcloud Talk zu einer echten Open-Source-Alternative zu proprietären Messenger- und Videokonferenzlösungen. Das ist besonders für Organisationen, Behörden und Unternehmen, die Wert auf Unabhängigkeit und Datenschutz legen, ein großer Gewinn.
          </p>

          <p className="mt-4 font-semibold">
            Wir von PathConnect hosten deine Nextcloud DSGVO-konform in Deutschland – inklusive Talk, Federation, Office-Integration und Single Sign-On.
          </p>

          <BlogImage 
            src={nextcloudTalkPathconnect}
            alt="PathConnect Nextcloud Federation Illustration"
            size="medium"
          />
        </BlogContent>
      )
    },

    de_DE: {
      title: "Nextcloud Talk – Federation: Nextcloud-übergreifend kommunizieren",
      formattedDate: "08. Juli 2025",
      excerpt: "So kommunizierst du sicher über mehrere Nextcloud-Instanzen hinweg mit der Federation-Funktion in Talk.",
      searchableContent: "Nextcloud Talk Federation serverübergreifende Kommunikation dezentrale Kommunikation Open Source Messenger DSGVO Talk-Federation",
      get content() { return post.translations.de.content; }
    }
  },

  get title() {
    return this.translations.de.title;
  },

  get formattedDate() {
    return this.translations.de.formattedDate;
  },

  get excerpt() {
    return this.translations.de.excerpt;
  },

  get content() {
    return this.translations.de.content;
  }
};

export default post;
